<template>
    <div class="date-class">
      <label for="startDate">Fecha de Inicio:</label>
      <input
        type="date"
        id="startDate"
        v-model="startDate"
        @input="emitDates"
      />

      <label for="endDate">Fecha de Fin:</label>
      <input
        type="date"
        id="endDate"
        v-model="endDate"
        @input="emitDates"
      />
    </div>
  </template>

<script>
export default {
  data () {
    return {
      startDate: '',
      endDate: '',
    }
  },
  methods: {
    emitDates () {
      // Emitir un evento con las fechas al componente padre
      this.$emit('update-dates', {
        startDate: this.startDate,
        endDate: this.endDate,
      })
    },
  },
}
</script>